<template>
  <!-- Un bouton au-dessus de la liste, les commandes dans sa fenêtre : la liste des équipements reste en haut. -->
  <div class="d-flex justify-end mb-2">
    <dialog-button
        :label="$t('onboarding.commissioning.member.button')"
        :title="$t('onboarding.commissioning.orders')"
        icon="mdi-package-variant-closed"
        :count="openOrders"
    >
      <equipment-orders-card
          :organization-id="organizationId"
          :query="query"
          holder="organization"
          :kinds="[kind]"
          kinds-for-organization-only
          :preset-who="presetWho"
          embedded
          @counts="openOrders = $event.open"
      />
    </dialog-button>
  </div>
</template>

<script>
import DialogButton from '@/components/shared/DialogButton.vue'
import EquipmentOrdersCard from './EquipmentOrdersCard.vue'
import { ORGANIZATION_KINDS } from '../CommissioningMixin'

/**
 * Les commandes d'une organisation, dans son onglet Bornes ou Compteurs : toutes celles de ce type
 * (pour l'organisation ou pour ses membres), et le bouton pour en commander une. Pour l'organisation, ce type ; pour
 * un membre ou une personne invitée, tout ce qui se commande pour elle, comme depuis sa fiche (un véhicule compris).
 * Un compteur ne se commande jamais pour l'organisation (il ne sert qu'à domicile) : depuis Compteurs, « pour un
 * membre » d'abord.
 */
export default {
  name: 'OrganizationCommissionings',

  components: { DialogButton, EquipmentOrdersCard },

  data() {
    return { openOrders: 0 }
  },

  props: {
    organizationId: { type: String, required: true },
    /** charging-point | meter-device */
    kind: { type: String, required: true },
  },

  computed: {
    presetWho() {
      return ORGANIZATION_KINDS.includes(this.kind) ? null : 'member'
    },
    query() {
      return { kind: this.kind }
    },
  },
}
</script>
